module.exports = __webpack_public_path__ + "assets/img/jingxin.2653026c.png";